import {} from "./types";

const initialState = {};

const financialProfile = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default financialProfile;
